<template>
  <div class="allergySelection">
      <LoadingComponent :is-show="isShowLoading" />
    <!-- <div class="header" @click="onSearch" >过敏史</div> -->
        <van-nav-bar
      class="first-bar"
      title="过敏史"
      :border="false"
      left-arrow
      fixed
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="content" >
      <div class="searchForm">
        <van-search
          v-model="value"
          show-action
          @input="valueChange"
        
          @search="onSearch"
          placeholder="请输入过敏成分，最多50字"
          maxlength="50"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div style="position: absolute;z-index: 1;padding:0 40px">
        <div style="margin-bottom:8px;font-size:18px">常见过敏成分</div>
        <button type="info" class="tag" v-for="item in getDefaultAllergyList" :key="item.name" @click="goBack(item)">{{item.name}}</button>
       
      </div>
      <div class="list" v-if="data.length>0" @scroll="scrollEvent" >
         <div v-for="item in data" :key="item.id" class="list-item" @click="goBack(item)" ><p style="padding: 0 15px;">{{item.name}}</p></div>
      </div>
      <div class="list" v-if="data.length==0&&value!=''" @scroll="scrollEvent" style="padding:0 0" >
          <div class="noneValue" v-html="title" @click="addManually"></div>
      </div>
    </div>
   
  </div>
  
</template>

<script>


let time;
import {irritabilityQueryList,getDefaultAllergy,getRecommendAllergy} from "@/api/video"
import LoadingComponent from '@/components/Loading'
export default {
 components:{
  LoadingComponent
 },
    name:"allergySelect",
    data() {
        return {
          title:"",
          isShowLoading:false,
            value:"",
            data:[],
            getDefaultAllergyList:[],
            isShow:false,
           form:{
              name:this.value,
             pageNum:1,
             pageSize:20,
             yn:1
           }
        }
    },
    created(){
      getRecommendAllergy(this.form).then(
            res=>{
              console.log(res)
            this.getDefaultAllergyList=res
            },
           
          )
         
        
    },
    mounted(){
      window.addInfo = this.addInfo
    },
    methods:{
        addManually(){//手动添加
            let reg2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
            if(reg2.test(this.value)){
              this.$toast("请输入合法过敏史")
              return
            }
            this.goBack({value:this.value,name:this.value})
        },
        onClickLeft() {
          this.$router.back()
        },
       addInfo(){
          this.goBack({name:this.value})
        },
        onSearch(){
          const that=this
          if(this.value=="")return
          this.isShowLoading=true
          irritabilityQueryList(this.form).then(
            res=>{
              console.log()
               this.isShowLoading=false
            this.data=res.result.list
            if(res.result.total==0){
              this.title="<div>暂未收录请点击<span style='color:blue' >手动添加</span></div>"
            }
           
            }, err=>{
                this.isShowLoading=false
            }
          )
           this.isShow=true
        },
        goBack(val) {
            console.log(val,'------------------------ ---------------------------');
            
          if (!this.$route.query.type) {
            this.$router.replace({
              name: 'interrogationInfoText',
              query: {
                value: val
              }
            })
          } else {
            this.$router.replace({
              name: 'askDockerChat',
              query: {
                value: val
              }
            })
          }
        },
        closeList(){
        
           this.isShow=false
        },
        valueChange(e){
          this.title=""
        clearTimeout(time)
       time= setTimeout(()=>{
          if(this.value==""){
             this.data=[]
          }else{
            this.form={
             name:this.value,
             pageNum:1,
             pageSize:20,
             yn:1
           }
          this.onSearch()
          }
        },500)
        },
        scrollEvent(e){
 const {scrollTop, clientHeight, scrollHeight} = e.target
      // console.log(scrollTop, clientHeight, scrollHeight)
      if (scrollTop + clientHeight === scrollHeight){
        this.form.pageSize=this.form.pageSize+10
       this.onSearch()
      }

        }
    },
    
}
</script>

<style lang="scss" scoped>
.allergySelection {
  

  background-color: white;
  .searchForm{
    width: 90%;
    margin: 0 auto;
    margin-top: 40px;
  }
  .header {
    text-align: center;
    font-size: 15px;
    height: 20px;
  
    font-weight: 800;
  }
  .list{
   position: absolute;
   height: 100%;
   width: 100%;
   z-index: 10;
    overflow: scroll;
    box-shadow: 3px 3px 3px rgb(240, 239, 239);
    padding: 0 0px ;
    background-color: white;
  }
  .list div{
   
    line-height: 40px;
   
  }
 
}
  .list .list-item{
    font-size: 15px;
  }
  .list .list-item:nth-child(1){
    border-top:1px solid rgb(221, 221, 221) ;
    border-bottom:1px solid rgb(221, 221, 221) ;
  }
   .list .list-item:nth-child(n+1){
  
    border-bottom:1px solid rgb(221, 221, 221) ;
   }
   .tag{
    display: inline-block;
    border: 1px solid rgb(187, 183, 183);
   background-color: rgb(243,243,245);
    margin: 5px 5px;
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 20px;
   }
   .noneValue{
   text-align: center;
   font-size: 14px;
   margin-top: 30px;
   }
</style>